<template>
    <div class="integrity_detail">
        <!-- 头部 -->
        <publicHeaders></publicHeaders>

        <div class="centerTab">
            <div><img src="../../assets/img/index/CXGheader.png" alt="" style="width: 100%;"></div>
            <div class="menuTab">
                <div class="top">
                    <span v-for="(item, index) in menuTabList" :key="index" @click="jump(item)">{{ item.name }}</span>
                </div>
            </div>
        </div>

        <!-- 主体 -->
        <div class="main">
            <div class="left">
                <div class="tab">
                    <span>您所在的位置：</span>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                      <el-breadcrumb-item>{{ documentTitle }}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div class="content">
                    <div class="top">
                        <div class="title" v-if="detail.title">{{ detail.title }}</div>
                        <div class="title" v-else>{{ detail.name }}</div>
                        <div class="info">
                            <span v-if="detail.source">{{ detail.source }}</span>
                            <div v-if="detail.source" class="interval"></div>
                            <span>http://www.qiyexinyong.org.cn</span>
                            <div class="interval"></div>
                            <span v-if="detail.publishTime">发布时间：{{ detail.publishTime.substring(0, 10) }}</span>
                        </div>
                    </div>
                    <div class="mainBody" v-loading="loading">
                        <img :src="baseUrl + detail.coverImg" alt="" v-if="detail.coverImg">
                        <img :src="baseUrl + detail.peopleImg" alt="" v-else>
                        <div v-html="detail.content"></div>
                    </div>
                    <div class="bottom">
                        <div class="group" v-if="detail.source">
                            <img src="../../assets/img/index/source.png" alt="">
                            <span>{{ detail.source }}</span>
                        </div>
                        <div class="group" style="margin-left: 30px;">
                            <img src="../../assets/img/index/time.png" alt="">
                            <span v-if="detail.publishTime">{{ detail.publishTime.substring(0, 10) }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right">
                <sideSearch></sideSearch>
            </div>
        </div>

        <!-- 底部 -->
        <div style="position: absolute;bottom: 0;left: 50%;transform: translateX(-50%);width: 100%;">
            <foot></foot>
        </div>
    </div>
</template>

<script>
import * as api from '../../api/api'
import { decrypt } from '../../utils/decode'
import publicHeaders from '../../components/header.vue'
import foot from '../../components/foot.vue'
import sideSearch from '../../components/sideSearch.vue'
import {baseURL} from '../../api/network.js';
export default {
    name: 'integrity_detail',
    components: {
        publicHeaders,
        foot,
        sideSearch
    },
    data() {
        return {
            documentTitle: '',
            baseUrl: baseURL,
            searchValue: '',
            menuTabList: [
                {
                    name: '首页',
                    title: '企业诚信官',
                    url: '/integrity'
                },
                {
                    name: '培训动态',
                    title: '培训动态',
                    url: '/integrity_list'
                },
                // {
                //     name: '新闻图片',
                //     title: '新闻图片',
                //     url: '/integrity_list'
                // },
                {
                    name: '活动通知',
                    title: '活动通知',
                    url: '/integrity_list'
                },
                {
                    name: '政策文件',
                    title: '政策文件',
                    url: '/integrity_list'
                },
                {
                    name: '优秀学员',
                    title: '优秀学员',
                    url: '/goodStudents'
                },
                {
                    name: '证书查询',
                    title: '证书查询',
                    url: ''
                },
                {
                    name: '师资介绍',
                    title: '师资介绍',
                    url: '/integrity_search'
                },
                {
                    name: '培训课程',
                    title: '培训课程',
                    url: '/integrity_list'
                },
                {
                    name: '推荐图书',
                    title: '推荐图书',
                    url: '/integrity_list'
                },
            ],
            options: [
                {
                    value: '新闻中心',
                    label: '新闻中心'
                },
                {
                    value: '企业资讯',
                    label: '企业资讯'
                },
                {
                    value: '活动通知',
                    label: '活动通知'
                },
                {
                    value: '政策法规',
                    label: '政策法规'
                },
                {
                    value: '信用标准',
                    label: '信用标准'
                },
                {
                    value: '信用认证',
                    label: '信用认证'
                },
                {
                    value: '信用案例',
                    label: '信用案例'
                },
                {
                    value: '信用研究',
                    label: '信用研究'
                },
                {
                    value: '信用管理',
                    label: '信用管理'
                },
                {
                    value: '信用指数',
                    label: '信用指数'
                },
            ],
            searchSelect: '',
            searchPlaceholder: '',
            detail: {
                // title: '海南：5年来制定30余项涉生态文明领域省级政策法规法制建设助力海南生态文明驶入快车道',
                // source: '企业信用建设服务平台',
                // web: 'http://www.ccbn.org.cn',
                // time: '2023/8/4',
                // updateTime: '2023-05-14',
                // content: '<div><img src="https://img1.jiemian.com/101/original/20180619/152941322442440200_a700xH.jpg" alt="" style="margin: 30px auto;"></div><p>8月1日，中国人民银行、国家外汇管理局召开2023年下半年工作会议。会议深入学习贯彻习近平新时代中国特色社会主义思想，落实党中央、国务院关于经济金融工作的决策部署，总结上半年工作，分析当前形势，部署下一阶段工作。中国人民银行党委书记、行长，国家外汇管理局党组书记、局长潘功胜出席会议并讲话。中国人民银行党委委员、国家外汇管理局党组成员出席会议。主题教育中央第三十三指导组副组长卢希到会指导。</p><p>会议认为，2023年以来，中国人民银行、国家外汇管理局认真贯彻党的二十大和中央经济工作会议精神，精准有力实施稳健的货币政策，有效防控金融风险，持续深化金融改革，切实改进金融服务，全面加强党的建设，各方面工作取得新成绩。</p><p>一是货币信贷和融资总量保持合理增长。保持流动性合理充裕，适时引导金融机构保持信贷总量适度、节奏平稳，实体经济融资成本稳中有降，金融支持实体经济力度保持稳固。</p><p>二是高质量发展重点领域和薄弱环节得到有效支持。调增支农支小再贷款、再贴现额度，延续实施普惠小微贷款支持工具、碳减排支持工具、支持煤炭清洁高效利用专项再贷款。指导金融机构用好设备更新改造专项再贷款。加强乡村振兴和农业强国建设金融服务。</p><p>三是外汇市场基本稳定。加强外汇市场“宏观审慎+微观监管”两位一体管理，优化企业汇率避险服务。人民币汇率在合理均衡水平上保持基本稳定。推动跨境贸易和投融资外汇便利化政策扩容提质。保障外汇储备资产安全、流动和保值增值。</p><p>四是重点领域金融风险得到有序处置。推动重点机构风险进一步化解。加快金融稳定保障基金积累。更好发挥存款保险功能。构建分级分段的银行风险监测、预警和硬约束早期纠正工作框架。延长“金融16条”有关政策适用期限，支持民营房企发行债券。加大保交楼金融支持力度。</p><p>五是金融改革开放深入推进。加强宏观审慎管理，完善系统性金融风险监测分析框架。组织开展国内系统重要性银行评估，落实附加监管要求。完善粤港澳大湾区“跨境理财通”业务试点。推动内地与香港利率“互换通”上线。</p><p>六是国际金融合作持续深化。积极开展重要金融外交，建设性参与二十国集团、国际货币基金组织等多边机制。推动建立国际清算银行人民币流动性安排。继续牵头做好二十国集团可持续金融工作。</p><p>七是金融服务与管理质效不断提升。加快推进金融法律体系建设。实施重要基础数据及资管产品等大数据统计。善始善终做好平台企业金融业务突出问题整改，加强常态化监管。深入开展金融领域关键信息基础设施安全保护工作。稳妥推进数字人民币研发。扎实推进国家金库工程建设。持续加强征信合规监管和金融消费者权益保护。加强高风险行业和机构反洗钱监管。有效发挥金融研究和参事建言献策作用。</p><p>会议指出，中国人民银行党委、国家外汇管理局党组坚持将政治建设摆在首位，全面从严治党向纵深推进。深入学习贯彻习近平总书记关于主题教育的重要指示批示精神，高标准高质量推进主题教育。扎实开展理论学习，大兴调查研究，深入开展干部队伍教育整顿。坚持以严的基调强化正风肃纪反腐。强化巡视和审计问题整改，全力配合经济责任审计。党校办学、工会和共青团工作、离退休干部服务、所属单位管理、集中采购、机关服务等工作质效持续提升。机构改革工作平稳推进。</p><p>会议要求，下半年，中国人民银行、国家外汇管理局系统要深刻领会中央关于经济形势的科学判断，进一步统一思想、坚定信心，切实抓好党中央、国务院决策部署贯彻落实，精准有力实施宏观调控，加强逆周期调节和政策储备，扎实推动经济高质量发展。</p><p>一是继续精准有力实施稳健的货币政策，持续改善和稳定市场预期，为实体经济稳定增长营造良好的货币金融环境。</p>',
            },
            correlationList: [
                // {
                //     title: '2023年8月信用领域十大事件盘点'
                // },
                // {
                //     title: '9月涉及信用的新规'
                // },
                // {
                //     title: '个人信用报告到娜里查'
                // },
                // {
                //     title: '个人为什么要查询本人信用报告'
                // },
                // {
                //     title: '什么是个人信用记录'
                // },
                // {
                //     title: '信用评级机构最新情况公布'
                // },
                // {
                //     title: '信贷产品的成本结构解析'
                // },
                // {
                //     title: '国务院决定修改的行政法规，涉及信用内容及信用内容及信用内容'
                // },
            ]
        }
    },
    created() {
        this.documentTitle = this.$route.query.documentTitle
        this.searchPlaceholder = this.$route.query.documentTitle
        document.title = this.$route.query.documentTitle
        if (this.$route.query.isPerson) {
            this.getPersonInfo(this.$route.query.id)
        } else {
            this.getInfo(this.$route.query.id)
        }
    },
    methods: {
        // 获取详情
        getInfo(id) {
            let _this = this
            _this.loading = true
            _this.detail = {}
            let params = {
                id: id,
            }
            api.getInfo(params).then(res => {
                let { data } = res
                console.log(data);
                if (data.status == 200) {
                    _this.detail = data.data
                    _this.loading = false
                } else {
                    _this.loading = false
                }
            })
            .catch(error => {
                _this.loading = false
            //   _this.$toast('网络错误，请检查网络')
            })
        },

        // 获取人物详情
        getPersonInfo(id) {
            let _this = this
            _this.loading = true
            let params = {
                id: id
            }
            api.getPersonInfo(params).then(res => {
                let { data } = res
                console.log(data);
                if (data.status == 200) {
                    _this.detail = data.data
                    _this.loading = false
                } else {
                    _this.loading = false
                }
            })
            .catch(error => {
            //   _this.$toast('网络错误，请检查网络')
                    _this.loading = false
            })
        },

        jump(item) {
            if (item.url != '') {
                this.$router.push({
                    path: item.url,
                    query: {
                        documentTitle: item.title
                    }
                })
                // let routeUrl = this.$router.resolve({
                //   path: item.url
                // });
                // // console.log(routeUrl);
                // window.open(routeUrl.href+ '?documentTitle=' + item.title, '_blank');
            }
        },
    }
}
</script>

<style lang="less" scoped>
.integrity_detail {
    position: relative;
    padding-bottom: 140px;
    .centerTab {
            width: 80%;
            @media only screen and (min-width: 769px) {
                min-width: 1152px;
            }
            margin: 0 auto;
            padding: 0 50px;
            margin-top: 10px;
            .menuTab {
                    margin-top: 15px;
                    color: #134AA6;
                    padding: 0 20px;
                    background-color: #E8F1FF;
                    .top {
                        padding: 10px 0;
                        display: flex;
                        span {
                            flex: 1;
                            cursor: pointer;
                            text-align: center;
                        }
                        span:nth-of-type(n+2) {
                            border-left: 1px solid #98C8F8;
                        }
                    }
                }
        }
    .main {
        width: 80%;
            @media only screen and (min-width: 769px) {
                min-width: 1152px;
            }
        padding: 15px 50px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        .left {
            flex: 3;
            margin-right: 5px;
            .tab {
                background-color: #F2F2F2;
                display: flex;
                align-items: center;
                font-size: 16px;
                padding: 5px 10px;
            }
            .content {
                min-height: 500px;
                border: 1px solid #D9D9D9;
                margin-top: 10px;
                padding: 20px;
                .top {
                    padding: 5px 0 20px;
                    border-bottom: 1px solid #DCDCDC;
                    .title {
                        font-size: 32px;
                        color: #666;
                    }
                    .info {
                        margin-top: 15px;
                        display: flex;
                        justify-content: left;
                        align-items: center;
                        color: #666;
                        font-size: 16px;
                    }
                    .interval {
                        width: 1px;
                        height: 20px;
                        background-color: #666;
                        margin: 0 25px;
                    }
                }
                .mainBody {
                    font-size: 20px;
                    line-height: 27px;
                    color: #666;
                    padding: 20px 0;
                    img {
                        margin: 0 auto;
                        max-width: 710px;
                        padding-bottom: 20px;
                    }
                    * {
                        font-family: 'Source Han Sans CN' !important;
                        color: #666 !important;
                        line-height: 27px !important;
                        font-size: 20px !important; 
                        text-align: left !important;
                    }
                }
                .bottom {
                    display: flex;
                    justify-content: right;
                    align-items: center;
                    margin-top: 30px;
                    .group {
                        display: flex;
                        align-items: center;
                        font-size: 20px;
                        color: #666;
                        img {
                            width: 16px;
                            height: 16px;
                            margin-right: 10px;
                        }
                    }
                }
            }
        }
        .right {
            flex: 1;
            margin-left: 5px;
        }
    }
}
</style>

